import styled from "styled-components";

export const SecondFoldWrapper = styled.div``;
